import React from 'react';
import InputGroup from '@bonprix/pattern-library/templates/input/Group.jsx';
import Select from '@bonprix/pattern-library/templates/input/Select.jsx';
import Label from '@bonprix/pattern-library/templates/input/Label.jsx';

const MAX_QUANTITY = 15;

export default function QuantitySelection({ quantity, texts, onChangeQuantity, onClick }) {
    const changeQuantity = (onChangeEvent) => {
        const newQuantity = onChangeEvent.target.value;
        onChangeQuantity(newQuantity);
    };

    const quantityOptions = [];
    for (let i = 1; i <= MAX_QUANTITY; i++) {
        quantityOptions.push(<option key={i} value={i}>{i}</option>);
    }

    if (quantity > MAX_QUANTITY) {
        quantityOptions.push(
            <option key='disabled' value={quantity} disabled>
                {quantity}
            </option>
        );
    }

    return (
        <InputGroup className="change-item__selection-input-group" attributes={{ onClick: onClick }}>
            <Label className="input-group__label">{texts.wk_anzahl}</Label>
            <Select
                name={'item.name' + '_quantity'}
                value={quantity}
                onChange={changeQuantity}
                placeholder={quantity}
                testRefs={{ 'test-ref__change-item-layer-quantity': '' }}
            >
                {quantityOptions}
            </Select>
        </InputGroup>
    );
}
